<template>
  <div class="v3-popup login-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content small">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title">{{ langData.loginPopupTitle }}</div>
      <div class="v3-popup-content-content">{{ langData.loginTip }}</div>
      <div class="v3-popup-content-footer">
        <div class="popup-login-btn btns" @click="handleLogin">{{ langData.nowLoginBtn }}</div>
        <div class="cancel-btn btns" @click="handleClose">{{ langData.cancelBtn }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";

import LanguageHook from "@hooks/language";

// 语言相关
const { langData } = LanguageHook();

const v3PopupState = inject("v3PopupState");

const gotoLogin = inject("gotoLogin");

const handleLogin = () => {
  gotoLogin();
  v3PopupState.loginTipPopupState = false;
};

const handleClose = () => {
  v3PopupState.loginTipPopupState = false;
};
</script>

<style scoped lang="less"></style>
